import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";

const faqs = [
  { q: "¿Cuál es el horario de servicio de GERPAT?", a: "Ofrecemos servicio de grúa y asistencia en carretera en las provincias de Lleida y Huesca. Contáctenos directamente para consultar disponibilidad y horarios de atención." },
  { q: "¿Qué zona de cobertura tienen?", a: "Cubrimos las provincias de Lleida y Huesca y sus zonas limítrofes. Para servicios especiales o de larga distancia, consúltenos directamente y le daremos presupuesto sin compromiso." },
  { q: "¿Trabajan con todas las compañías de seguros?", a: "Sí, trabajamos con todas las compañías aseguradoras del mercado español. Nos encargamos de toda la gestión y papeleo con su aseguradora para que usted no tenga que preocuparse de nada." },
  { q: "¿Cuánto tarda en llegar la grúa?", a: "Nuestro tiempo medio de respuesta es de 30-45 minutos en zona urbana y de 45-60 minutos en zonas rurales o de montaña. Siempre intentamos llegar lo antes posible." },
  { q: "¿Qué tipos de vehículos pueden remolcar?", a: "Disponemos de equipos para todo tipo de vehículos: turismos, furgonetas, camiones, autobuses, maquinaria agrícola e industrial. Tenemos grúas de diferentes capacidades para adaptarnos a cada necesidad." },
  { q: "¿Cómo funciona el servicio de compra-venta de vehículos?", a: "Disponemos de un stock de vehículos comerciales e industriales revisados y en perfecto estado. Puede visitarnos en nuestras instalaciones o contactarnos por teléfono para consultar disponibilidad y precios. También compramos vehículos." },
  { q: "¿Ofrecen garantía en los vehículos que venden?", a: "Sí, todos los vehículos de nuestra flota de venta pasan una revisión técnica completa antes de ser puestos a la venta. Ofrecemos garantía y asesoramiento en la compra." },
  { q: "¿Pueden transportar maquinaria agrícola o de construcción?", a: "Sí, contamos con plataformas y equipos especializados para el transporte de maquinaria pesada. Disponemos de todos los permisos necesarios para transporte especial y gestionamos los trámites administrativos." },
  { q: "¿Cómo puedo solicitar un presupuesto?", a: "Puede solicitar presupuesto llamándonos al teléfono de contacto, enviándonos un WhatsApp o rellenando el formulario de contacto de nuestra web. Le responderemos en el menor tiempo posible." },
  { q: "¿Qué debo hacer si tengo una avería en carretera?", a: "Póngase en un lugar seguro, active las luces de emergencia y coloque los triángulos de señalización. Luego llámenos al número de emergencias y le atenderemos de inmediato. No abandone el vehículo en la calzada." },
];

export default function FaqPage() {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="relative h-64 flex items-center justify-center overflow-hidden">
        <img src="https://public.readdy.ai/ai/img_res/f0c69a37b3ea62cdb731338feb67f2a1.jpg" alt="FAQ GERPAT" className="absolute inset-0 w-full h-full object-cover object-top" />
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="relative z-10 text-center px-4">
          <span className="text-[#FF6B35] text-xs font-bold uppercase tracking-widest">Resolvemos sus dudas</span>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mt-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>PREGUNTAS FRECUENTES</h1>
        </div>
      </section>

      <section className="py-20 bg-[#f8f7f5]">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <div className="space-y-3">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white rounded-xl overflow-hidden border-l-4 border-[#FF6B35]">
                <button
                  className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-[#f8f7f5] transition-colors"
                  onClick={() => setOpen(open === i ? null : i)}
                >
                  <span className="font-semibold text-[#1a1a1a] text-sm pr-4">{faq.q}</span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-[#FF6B35] text-lg`}></i>
                  </div>
                </button>
                {open === i && (
                  <div className="px-6 pb-5">
                    <p className="text-gray-500 text-sm leading-relaxed">{faq.a}</p>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mt-12 bg-[#1a1a1a] rounded-2xl p-8 text-center">
            <h3 className="text-white font-extrabold text-xl mb-2" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>¿NO ENCUENTRA SU RESPUESTA?</h3>
            <p className="text-gray-400 text-sm mb-6">Contáctenos directamente y le ayudaremos encantados.</p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <a href="tel:+34638250936" className="flex items-center justify-center gap-2 bg-[#FF6B35] hover:bg-[#e55a25] text-white font-bold px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm">
                <i className="ri-phone-fill"></i> Llamar ahora
              </a>
              <Link to="/contacto" className="flex items-center justify-center gap-2 border border-white/30 hover:border-[#FF6B35] text-white font-bold px-6 py-3 rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm">
                Formulario de contacto
              </Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
